import React from "react";
import { Navigate } from "react-router-dom";
import { useGlobalContext } from "./Context/GlobalContext";
import ShowToastMsg from "./Extra/ShowToastMsg";

const PrivateRoute = ({
  element,
  allowedRoles = [],
  requiredPermission = null,
}) => {
  const { userData } = useGlobalContext();

  // Not logged in
  if (!userData) {
    // ShowToastMsg({
    //   type: "danger",
    //   toastText: "Please log in to access this page.",
    //   duration: 4000,
    // });
    return <Navigate to="/LogIn" replace />;
  }

  // Check role-based access
  const hasRoleAccess = allowedRoles.includes(userData.role);

  // Check permission-based access for dataEntry role
  let hasPermissionAccess = true;

  if (userData.role === "dataEntry" && requiredPermission) {
    hasPermissionAccess = Array.isArray(userData.accessRight.split(","))
      ? userData.accessRight.includes(requiredPermission)
      : false;
  }
  if (!hasRoleAccess || !hasPermissionAccess) {
    ShowToastMsg({
      type: "danger",
      toastText: `Sorry, ${userData.username}! You do not have permission to access this page.`,
    });
    if (userData.role === "user") {
      return <Navigate to="/" replace />;
    } else {
      return <Navigate to="/InsertData" replace />;
    }
  }

  return element;
};

export default PrivateRoute;
